const loading = "Loading learning content...";
const loadingContent = "Loading content...";
const errorOccurred = "Error Occurred";
const cannotLoadContent = "Unable to load content.";
const errorLoadingContent = "An error occurred while loading content.";
const lectureNotFound = "Lecture not found";
const backToList = "Back to List";
const goBack = "Go Back";
const exit = "Exit";
const previous = "Previous";
const next = "Next";
const nextStep = "Next Step";
const nextTo = "Next";
const start = "Start";
const close = "Close";
const dashboard = {
  warmup: "Warm-up",
  warmupQuiz: "Warm-up Quiz",
  warmupDescription: "Brain stretch before learning",
  warmupFullDescription: "Prepare with a quick quiz before studying",
  test: "Test",
  testQuiz: "Review Quiz",
  testDescription: "Master what you learned",
  testFullDescription: "Check what you've learned",
  wrapup: "Wrapup",
  wrapupQuiz: "Closing Quiz",
  wrapupDescription: "Advanced learning questions",
  wrapupFullDescription: "A comprehensive quiz to wrap up your learning",
  aiq: "AIQ",
  aiqDescription: "AI-based customized questions",
  videoLesson: "Video Lesson",
  videoLecture: "Video Lecture",
  videoDescription: "Learn concepts with a video",
  videoDescriptionWithDuration: "Learn concepts with a {{minutes}} min video",
  videoNotProvided: "Video not provided",
  videoAfterWarmup: "Available after completing warm-up",
  masterKeyConcepts: "Master key concepts",
  noQuestionsAvailable: "No questions available",
  correctAnswersSummary: "{{correct}}/{{total}} correct ({{score}} pts)",
  startTitle: "Start {{title}}",
  retakeAll: "Retake All",
  incorrectOnly: "Incorrect Only",
  retryIncorrect: "Retry Incorrect Questions",
  retryIncorrectOnly: "Retry Incorrect Only",
  mustCompleteWarmup: "You must complete the warm-up first",
  warmupIncluded: "Warm-up included",
  warmupNotIncluded: "No warm-up",
  videoIncluded: "Video lecture included",
  videoNotIncluded: "No video lecture",
  reviewIncluded: "Review questions included",
  reviewNotIncluded: "No review questions",
  wrapupIncluded: "Wrapup included",
  aiqIncluded: "AIQ included",
  completedBadge: "Completed",
  lockedBadge: "Locked"
};
const rewatch = "Rewatch";
const completed = {
  title: "Learning Complete!",
  titleWithEmoji: "Learning Complete! 🎉",
  subtitle: 'You completed "{{title}}"',
  successMessage: "You have successfully completed this lesson.",
  results: "Learning Results",
  videoWatched: "Video Watched",
  quizScore: "Quiz Score",
  completionTime: "Completion Time",
  scorePoints: "{{score}} pts",
  nextLearning: "Next Lesson",
  restudy: "Re-study",
  backToLearningList: "Back to List",
  encouragement: "Consistent learning is the key to improvement! 💪"
};
const progress = {
  learningProgress: "Learning Progress",
  viewingCompleted: "Viewing Completed",
  percentWatched: "{{percent}}% Watched",
  percentRequired: "({{percent}}% required)",
  videoCompletedMessage: "🎉 You have completed watching the video!",
  minuteVideo: "{{minutes}} min video"
};
const tips = {
  title: "💡 Learning Tips",
  warmup: "• Check your understanding with the warm-up quiz",
  video: "• Your learning will be recorded when you watch the video completely",
  review: "• Review what you learned with the review quiz",
  wrapup: "• Complete your learning with the closing quiz"
};
const video = {
  notReady: "Video is not ready",
  notFound: "Video not found",
  noVideoForContent: "No video is associated with this content.",
  noIdProvided: "Video ID was not provided",
  cannotLoadInfo: "Unable to load video information",
  urlNotFound: "Video URL not found. Please try again later.",
  loadError: "An error occurred while loading video information",
  networkError: "Network error occurred. Retrying...",
  cannotPlay: "An error occurred while playing video",
  hlsNotSupported: "This browser does not support HLS videos",
  retry: "Retry",
  normal: "Normal"
};
const playerEn = {
  loading,
  loadingContent,
  errorOccurred,
  cannotLoadContent,
  errorLoadingContent,
  lectureNotFound,
  backToList,
  goBack,
  exit,
  previous,
  next,
  nextStep,
  nextTo,
  start,
  close,
  dashboard,
  rewatch,
  completed,
  progress,
  tips,
  video
};
export {
  backToList,
  cannotLoadContent,
  close,
  completed,
  dashboard,
  playerEn as default,
  errorLoadingContent,
  errorOccurred,
  exit,
  goBack,
  lectureNotFound,
  loading,
  loadingContent,
  next,
  nextStep,
  nextTo,
  previous,
  progress,
  rewatch,
  start,
  tips,
  video
};
//# sourceMappingURL=player.json.js.map
